import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    body {
        overflow-x: hidden;
        font-family: 'Roboto', sans-serif;
        color: #FFF;
        background-color: #000000;
        width: 100%;
        overflow-y: ${props => props.mobileMenuOpen ? "hidden" : "auto"}
    }
    h1,h2,h3 {
        font-family: 'Roboto Condensed', sans-serif;
        text-transform: uppercase;
    }
    h1 {
        font-size: 30px;
        line-height: 40px;
        @media (max-width: 900px) {
            font-size: 18px;
        }
    }
    h2 {
        font-size: 24px;
        line-height: 32px;
    }
    h3 {
        font-size: 20px;
        line-height: 28px;
    }
    p {
        font-size: 16px;
        margin: 0;
    }
    a {
        text-decoration: none;
    }
    button {
        font-size: 16px;
        font-weight: 700;
        font-family: 'Roboto Condensed',sans-serif;
        text-transform: uppercase;
        border: none;
    }
    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .b-scrollbar {
        width: 100px;
        height: 100px;
        overflow: scroll;
        position: absolute;
        top: -9999px;
    }
    .text-large {
        font-size: 44px;
        line-height: 54px;
    }
    .text-regular {
        font-size: 18px;
        line-height: 28px;
    }
    .text-medium {
        font-size: 14px;
        line-height: 18px;
    }
    .text-small {
        font-size: 12px;
        line-height: 12px;
    }
    .uppercase {
        text-transform: uppercase;
    }
    .Modal {
        position: absolute;
        width                 : 600px;
        padding               : 37px 31px 41px 40px;
        top                   : 20%;
        left                  : 50%;
        right                 : auto;
        bottom                : auto;
        margin-right           : -50%;
        transform             : translate(-50%, -50%);
        background-color       : #000000;
        border-radius          : 0px;
        border                 : 0;
        border-top             : 3px solid #d6001c;
        @media(max-width:900px){
            width: 410px;
        }
        @media(max-width:560px){
            width: 340px;
        }
    }
    .Modal:focus {
        outline: none; 
    }
    .Overlay {
        background-color: rgba(22, 23, 24, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    *::-webkit-input-placeholder {
        color: #FFFFFF;
    }
    *:-moz-placeholder {
        color: #FFFFFF;
        opacity: 1;
    }
    *::-moz-placeholder {
        color: #FFFFFF;
        opacity: 1;
    }
    *:-ms-input-placeholder {
        color: #FFFFFF;
    }
    *::-ms-input-placeholder {
        color: #FFFFFF;
    }
    *::placeholder {
        color: #FFFFFF;
    }
    input[type="date"]{
        font-family: 'Roboto';
        position: relative;
    }
    input[type="date"]::-webkit-calendar-picker-indicator {
        opacity: 0;
        left: -25px;
        width: 100%;
        cursor: pointer;
        position: absolute;
    }
    input[type="date"]::-webkit-clear-button {
        display: none;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
`
export default GlobalStyle;